"use client";

import { usePathname, useRouter } from "next/navigation";
import { useLocale, useTranslations } from "next-intl";
import { setLang } from "@/state/slices/settingSlice";
import { useAppDispatch } from "@/state/redux";

export function LanguageSwitcher() {
  const t = useTranslations("NavBar");
  const router = useRouter();
  const pathname = usePathname();
  const locale = useLocale();

  const toggleLocale = locale === "ar" ? "en" : "ar";
  const dispatch = useAppDispatch();

  // Remove the current locale from the path
  const pathWithoutLocale = pathname.replace(/^\/(ar|en)/, "");

  const handleSwitch = () => {
    router.replace(`/${toggleLocale}${pathWithoutLocale}`);
    dispatch(setLang({ lang: toggleLocale }));
  };

  return (
    <button
      onClick={handleSwitch}
      style={{ padding: "8px 16px", borderRadius: "4px" }}
    >
      {t("switcher")}
    </button>
  );
}
